export default __webpack_public_path__ + "static/media/svg-4.d5a150ed.svg";